export default {
    data(){
        return{
    cn: {
      /* ===================== FOOTER_NAME ======================*/
  
      footer_name: "云翰虹章",
  
      /* ===================== EMAIL ======================*/
  
      footer_email: "邮箱 ",
  
        /* ===================== PHONE NO ======================*/

      footer_phone_no: "电话: ",

      /* ===================== LOCATION ======================*/
  
      footer_address: "地址: 宁波鄞州诺丁汉创新创业大楼",
    }
  }
  }
  };
  